import Vue from 'vue'
import Router from 'vue-router'
import home from '@/pages/home'
import screen from '@/pages/screen'
import area_detail from '@/pages/area_detail'
import select_city from '@/pages/select_city'
import search from '@/pages/search'
import make_complaints from '@/pages/make_complaints'
import business_trend from '@/pages/business_trend'
import company_details from '@/pages/company_details'
import business_rank from '@/pages/business_rank'
import market_price from '@/pages/market_price'
import village_list from '@/pages/village_list'
import traffic_matching from '@/pages/traffic_matching'
import area_list from '@/pages/area_list'
import area_contrast from '@/pages/area_contrast'
import village_contrast from '@/pages/village_contrast'
import cell_list from '@/pages/cell_list'
import cell_detail from '@/pages/cell_detail'
import cell_market_price from '@/pages/cell_market_price'
import cell_trend from '@/pages/cell_trend'
import region_detail from '@/pages/region_detail'
import draw_market_price from '@/pages/draw_market_price'
import draw_company_details from '@/pages/draw_company_details'
import draw_traffic_matching from '@/pages/draw_traffic_matching'
import draw_village_list from '@/pages/draw_village_list'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/screen',
      name: 'screen',
      component: screen
    },
    {
      path: '/area_detail',
      name: 'area_detail',
      component: area_detail
    },
    {
      path: '/select_city',
      name: 'select_city',
      component: select_city
    },
    {
      path: '/search',
      name: 'search',
      component: search
    },
    {
      path: '/make_complaints',
      name: 'make_complaints',
      component: make_complaints
    },
    {
      path: '/business_trend',
      name: 'business_trend',
      component: business_trend
    },
    {
      path: '/company_details',
      name: 'company_details',
      component: company_details
    },
    {
      path: '/business_rank',
      name: 'business_rank',
      component: business_rank
    },
    {
      path: '/market_price',
      name: 'market_price',
      component: market_price
    },
    {
      path: '/village_list',
      name: 'village_list',
      component: village_list
    },
    {
      path: '/traffic_matching',
      name: 'traffic_matching',
      component: traffic_matching
    },
    {
      path: '/area_list',
      name: 'area_list',
      component: area_list
    },
    {
      path: '/area_contrast',
      name: 'area_contrast',
      component: area_contrast
    },
    {
      path: '/village_contrast',
      name: 'village_contrast',
      component: village_contrast
    },
    {
      path: '/cell_list',
      name: 'cell_list',
      component: cell_list
    },
    {
      path: '/cell_detail',
      name: 'cell_detail',
      component: cell_detail
    },
    {
      path: '/cell_market_price',
      name: 'cell_market_price',
      component: cell_market_price
    },
    {
      path: '/cell_trend',
      name: 'cell_trend',
      component: cell_trend
    },
    {
      path: '/region_detail',
      name: 'region_detail',
      component: region_detail
    },
    {
      path: '/draw_market_price',
      name: 'draw_market_price',
      component: draw_market_price
    },
    {
      path: '/draw_company_details',
      name: 'draw_company_details',
      component: draw_company_details
    },
    {
      path: '/draw_traffic_matching',
      name: 'draw_traffic_matching',
      component: draw_traffic_matching
    },
    {
      path: '/draw_village_list',
      name: 'draw_village_list',
      component: draw_village_list
    }
  ],
  scrollBehavior(to, from,savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js